module.exports = "<div class=\"<%= info %>\" ng-hide=\"$ctrl.infoBarHidden\">\r\n    <span class=\"<%= icon %> fa fa-info-circle\"></span>\r\n    {{'fnol.common.directives.loss-location.Click anywhere on the map to set a location or drag the pin to adjust it.'|translate}}\r\n</div>\r\n<div class=\"<%= map %>\" id=\"{{$ctrl.mapName || 'googleMapsComponent'}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/common/directives/LossLocationMap/map.html
// module id = 626
// module chunks = 0